module.exports = __webpack_public_path__ + "img/logo-l.d5e1c992.png";